// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__MHlZY","row":"ProcedureTreatmentSummary_row__3Hh-S"};